export function getPrecacheFrames(currentFrame: number, lastFrame: number) {
    if (currentFrame === 0)
        return [1];
    if (currentFrame === lastFrame - 1)
        return [currentFrame - 1];

    return [currentFrame - 1, currentFrame + 1];
}
